import React, { useState, useEffect } from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import Layout from "./Layout/layout";
import { connect } from "react-redux";
import { setUser } from "./redux/actions/AuthActions";
import Splash from "./screens/splash/splash";
import { requestForToken, onMessageListener } from "./firebase";
import { notification } from "antd";
import { getNotifications, getUnreadNotificationsCount } from './redux/actions/NotificationAction'

const App = ({ component: Component, rest, currentUser, isRTL, menu }) => {
  const [showSplash, setShowSplash] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (location.pathname === "/Login") {
      setShowSplash(false);
      return;
    }

    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  // ✅ تسجيل الـ Service Worker + طلب التوكن بعد تسجيل الدخول
  useEffect(() => {
    if (currentUser) {
      if ("serviceWorker" in navigator) {
        navigator.serviceWorker
          .register("/firebase-messaging-sw.js")
          .then((registration) => {
            registration.update(); // 🔄 تحديث ملف SW فوراً لمنع تشغيل النسخة القديمة المحفوظة في الكاش
            console.log("Service Worker registered with scope:", registration.scope);
            // ✅ بنمرر الـ registration عشان الـ FCM token يتربط بالـ SW الصح
            // ده اللي بيخلي النوتيفيكيشن توصل حتى لو المتصفح مقفول
            requestForToken(currentUser.token, isRTL, registration);
          })
          .catch((err) => {
            console.error("Service Worker registration failed:", err);
          });
      }
    }
  }, [currentUser]);


  // ✅ (Notification UI)
  useEffect(() => {
    if (!currentUser) return;

    const unsubscribe = onMessageListener((payload) => {
      console.log("📩 Foreground Message:", payload);

      // 🔊 
      const notifSound = new Audio(require("./assets/sounds/notif.mp3"));
      notifSound.play().catch(() => { });

      notification.open({
        message: payload?.notification?.title || payload?.data?.title || "New Notification",
        description: payload?.notification?.body || payload?.data?.body || "You have a new update.",
        placement: "topRight",
        duration: 5,
      });

      getNotifications(1, true, currentUser.token);
      getUnreadNotificationsCount(currentUser.token);
    });

    return () => {
      if (typeof unsubscribe === "function") {
        unsubscribe();
      }
    };
  }, [currentUser]);


  if (showSplash) {
    return <Splash />;
  }

  let marginLeft = 0, marginRight = 0;
  if (!isMobile) {
    if (menu === true) {
      marginLeft = 80;
      if (isRTL) {
        marginLeft = 'auto';
        marginRight = 80;
      } else {
        marginLeft = 80;
        marginRight = 'auto';
      }
    } else {
      marginLeft = 230;
      if (isRTL) {
        marginLeft = 'auto';
        marginRight = 230;
      } else {
        marginLeft = 230;
        marginRight = 'auto';
      }
    }
  }

  if (currentUser == null) return <Redirect to="/Login" />;
  let userData = localStorage.getItem("@USERSAAEI");
  if (!userData) return <Redirect to="/Login" />;

  return (
    <Route
      {...rest}
      render={(routeProps) => (
        <Layout marginLeft={marginLeft} marginRight={marginRight} collapsed={menu}>
          <Component {...routeProps} />
        </Layout>
      )}
    />
  );
};

const mapToStateProps = (state) => ({
  currentUser: state.auth.currentUser,
  isRTL: state.lang.isRTL,
  menu: state.menu.menu,
  getNotifications,
  getUnreadNotificationsCount,
});

const mapDispatchToProps = {
  setUser,
};

export default connect(mapToStateProps, mapDispatchToProps)(App);

